import React from "react"
import { Route, Switch } from "react-router-dom"
import ProtectedRoute from "./ProtectedRoute"
import ProtectedRouteWithoutCompany from "./ProtectedRouteWithoutCompany"
import Login from "../pages/Login"
import Shoots from "../pages/Shoots"
import MyShoots from "../pages/MyShoots"
import Clients from "../pages/Clients"
import Gigs from "../pages/Gigs"
import MyBilling from "../pages/Billing/MyBilling"
import Roles from "../pages/Roles"
import Profile from "../pages/Profile"
import Companies from "../pages/Companies"
import Crew from "../pages/Crew"
import iFrameCrewIndex from "../pages/Crew/iFrameCrewIndex"
import NotFound from "../pages/NotFound"
import MagicLink from "../pages/MagicLink"
import CallSheet from "../pages/CallSheet"
import PrivacyPolicy from "../pages/PrivacyPolicy"
import ProtectedRouteADUsers from "./ProtectedRouteADUsers"
import ShootWrapper from "../pages/Shoot/wrapper"
import ClientInvoice from "../pages/ClientInvoice"
import Billing from "../pages/Billing/index"
import OldBilling from "../pages/Billing/OldBilling"
import ClientEstimate from "../pages/ClientEstimate/index"
import DealMemo from "../pages/DealMemo/index"
import CrewBilling from "../pages/CrewBilling"
import SoloInvoice from "../pages/Billing/pages/solo-invoice"
import SoloEstimate from "../pages/Billing/pages/solo-estimate"
import EstimatePreview from "../pages/Billing/pages/estimate-preview"
import InvoicePreview from "../pages/Billing/pages/invoice-preview"
import expenses from "../pages/Billing/pages/expenses"
import ClientPrivacyPolicy from "../pages/Clients/ClientPrivacyPolicy/index"
import CrewPrivacyPolicy from "../pages/Crew/CrewPrivacyPolicy/index"
import Disconnect from "../pages/Disconnect"
import resetProfile from "../pages/Profile/resetProfile"

export default ({ childProps }) => (
  <Switch>
    <Route
      path="/deal-memo/:short_code"
      component={DealMemo}
      props={childProps}
    />
    <Route path="/disconnect" component={Disconnect} props={childProps} />
    <Route
      path="/crew-mama-passwrd-rst/:user_id"
      render={props => {
        const parts = window.location.pathname.substring(1).split("/")
        childProps.match.params = props.match.params
        if (parts && parts[0] && Number(parts[0])) {
          return <Profile {...childProps} />
        } else {
          return <Crew {...childProps} makeSearches={true} />
        }
      }}
    />
    <Route
      path="/crew-bill/:short_code"
      component={CrewBilling}
      props={childProps}
    />
    <Route
      path="/estimate/:short_code"
      component={ClientEstimate}
      props={childProps}
    />
    <Route
      path="/invoice/:short_code"
      component={ClientInvoice}
      props={childProps}
    />
    <Route exact path="/login" component={Login} />
    <Route exact path="/register" component={Login} />

    <ProtectedRoute exact path="/roles" component={Roles} props={childProps} />
    <ProtectedRoute
      exact
      path="/clients"
      component={Clients}
      props={childProps}
    />
    <Route
      exact
      path="/clients/privacy-policy"
      component={props => <ClientPrivacyPolicy {...props} />}
    />
    <ProtectedRoute
      exact
      path="/billing"
      component={Billing}
      props={childProps}
    />
    <ProtectedRoute
      exact
      path="/stripe-billing"
      component={OldBilling}
      props={childProps}
    />
    <Route exact path="/my-billing" component={MyBilling} props={childProps} />
    <ProtectedRoute
      exact
      path="/billing/expenses"
      component={expenses}
      props={childProps}
    />
    <ProtectedRoute
      exact
      path="/shoots"
      component={Shoots}
      props={childProps}
    />
    <Route
      path="/billing/solo-estimate/:id/preview"
      component={EstimatePreview}
      props={childProps}
    />
    <Route
      path="/billing/solo-invoice/:id/preview"
      component={InvoicePreview}
      props={childProps}
    />
    <Route
      path="/solo-estimate/:unique_string"
      component={EstimatePreview}
      props={childProps}
    />
    <Route
      path="/solo-invoice/:unique_string"
      component={InvoicePreview}
      props={childProps}
    />
    <Route
      path="/billing/solo-estimate/:id"
      component={SoloEstimate}
      props={childProps}
    />
    <Route
      path="/billing/solo-invoice/:id"
      component={SoloInvoice}
      props={childProps}
    />
    <ProtectedRoute
      path="/shoots/:shoot_id"
      component={ShootWrapper}
      props={childProps}
    />
    {/* <ProtectedRoute
exact
path="/shoots/:shoot_id/details"
component={CallSheet}
props={childProps}
/> */}
    <ProtectedRouteWithoutCompany
      exact
      path="/shoots/:shoot_id/details"
      component={CallSheet}
      props={childProps}
    />

    <ProtectedRoute
      exact
      path="/companies"
      component={Companies}
      props={childProps}
    />
    <Route
      exact
      path="/privacy-policy"
      component={props => <PrivacyPolicy {...props} />}
    />
    {/* <Route exact path="/crew" component={Crew} /> */}
    <Route exact path="/crew" component={iFrameCrewIndex} />
    <Route
      exact
      path="/crew/privacy-policy"
      component={props => <CrewPrivacyPolicy {...props} />}
    />
    <Route exact path="/gigs" component={Gigs} />
    {/* <Route exact path="/my-shoots" component={MyShoots} props={childProps} /> */}
    <Route exact path="/my-shoots" component={MyBilling} props={childProps} />
    <Route
      exact
      path="/my-shoots/:shoot_id/details"
      component={CallSheet}
      props={childProps}
    />
    <ProtectedRouteADUsers
      path="/my-shoots/:shoot_id"
      component={ShootWrapper}
      props={childProps}
    />
    <Route path="/crew/:user_id" component={Crew} props={childProps} />
    <Route path="/start/:short_code/*" component={MagicLink} />
    <Route path="/start/:short_code" component={MagicLink} />

    <Route exact path="/public/shoots/:shoot_id" component={CallSheet} />

    <Route
      path="/:user_id"
      render={props => {
        const parts = window.location.pathname.substring(1).split("/")
        childProps.match.params = props.match.params
        if (parts && parts[0] && Number(parts[0])) {
          return <Profile {...childProps} />
        } else {
          return <Crew {...childProps} makeSearches={true} />
        }
      }}
    />
    {/* <Route path="/" exact component={Crew} props={childProps} /> */}
    <Route path="/" exact component={iFrameCrewIndex} props={childProps} />
    {/* Finally, catch all unmatched routes */}
    <Route component={NotFound} />
  </Switch>
)
